import React from 'react';
import { useTranslation } from 'react-i18next';
import FoxAvatar from '../illustrations/FoxAvatar.jsx';
import './AppViewMock.css';

/**
 * A drawn screen from the Revetall app: a small header with menu, summary boxes and a table
 * with a status tag per row (e.g. which customers have paid and who is overdue).
 * Built in HTML so the text wraps nicely.
 * @param {Object} props
 * @param {{nav: string[], active: string, title: string,
 *   summary: Array<{label: string, value: string}>, columns: string[],
 *   rows: Array<{label: string, status: 'paid'|'overdue', text: string, amount: string}>}} props.app
 *   Texts from `features.<id>.app`
 * @returns {JSX.Element} App screen
 */
function AppViewMock({ app }) {
  const { t } = useTranslation();

  return (
    <div className="app-view-mock">
      <div className="app-view-header" aria-hidden="true">
        <FoxAvatar className="app-view-avatar" />
        <span className="app-view-name">{t('chatMock.name')}</span>
        <span className="app-view-nav">
          {app.nav.map((item) => (
            <span key={item} className={`app-view-nav-item${item === app.active ? ' is-active' : ''}`}>
              {item}
            </span>
          ))}
        </span>
      </div>

      <div className="app-view-body">
        <p className="app-view-title">{app.title}</p>

        <div className="app-view-summary">
          {app.summary.map((box) => (
            <div key={box.label} className="app-view-summary-box">
              <span className="app-view-summary-label">{box.label}</span>
              <span className="app-view-summary-value">{box.value}</span>
            </div>
          ))}
        </div>

        <div className="app-view-table" role="table">
          <div className="app-view-row app-view-row--head" role="row">
            {app.columns.map((column) => (
              <span key={column} role="columnheader">
                {column}
              </span>
            ))}
          </div>
          {app.rows.map((row) => (
            <div key={row.label} className="app-view-row" role="row">
              <span className="app-view-cell-label" role="cell">
                {row.label}
              </span>
              <span role="cell">
                <span className={`app-view-status is-${row.status}`}>{row.text}</span>
              </span>
              <span className="app-view-cell-amount" role="cell">
                {row.amount}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AppViewMock;
